import React from 'react';
import Dialog from '@mui/material/Dialog';
import { TransitionProps } from '@mui/material/transitions';
import { Slide } from '@mui/material';
import { GrClose } from 'react-icons/gr';

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) => (
    <Slide direction="up" ref={ref} {...props} />
  ),
);

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  minWidth?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
  maxWidth?: any;
  setCustomClass?: boolean;
  title?: React.ReactNode;
}

export default function DialogBox({
  children,
  show,
  setShow,
  minWidth = '450px',
  maxWidth = 'md',
  setCustomClass = false,
  title,
}: Props) {
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth}
      open={show}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setShow(false)}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: {
          borderRadius: '10px',
          minWidth,
        },
      }}
    >
      {/* Header row: title left, close icon right */}
      {(title || title === '') && (
        <div
          className={
            setCustomClass
              ? 'flex items-center justify-between px-4 pt-3 pb-0'
              : 'flex items-center justify-between p-3'
          }
        >
          <div className="card-title" style={{ fontSize: '30px' }}>{title}</div>
          <button
            type="button"
            className="cursor-pointer hover:scale-125 ml-2 p-0 bg-transparent border-0"
            onClick={() => setShow(false)}
            aria-label="Close"
          >
            <GrClose />
          </button>
        </div>
      )}
      {children}
    </Dialog>
  );
}
